/* MALLIENA v7 video wall: vertical clips side by side on wide screens, each frame shown whole and sharp.
   Each column plays its own clip and moves on to the next one when it ends. */
window.MLNAWall=function(box,urls,autoplay){
  var n=urls.length,cols=[],muted=true,running=false;
  function rend(u,w){return w<=460?u.replace('HD-1080p-7.2Mbps','HD-720p-4.5Mbps'):u;}
  function build(){
    box.innerHTML='';cols=[];
    var h=box.clientHeight||700,w=box.clientWidth||1200;
    var c=Math.round(w/(h*9/16));c=Math.max(2,Math.min(c,n,6));
    var cw=w/c;
    for(var k=0;k<c;k++){(function(k){
      var el=document.createElement('video');el.muted=true;el.playsInline=true;el.preload='auto';el.setAttribute('playsinline','');el.setAttribute('muted','');
      el.idx=k%n;el.src=rend(urls[el.idx],cw);
      el.addEventListener('playing',function(){el.classList.add('is-on');});
      el.addEventListener('ended',function(){el.classList.remove('is-on');el.idx=(el.idx+(n>c?c:1))%n;el.src=rend(urls[el.idx],cw);el.load();if(running){var p=el.play();if(p&&p.catch)p.catch(function(){});}});
      el.addEventListener('error',function(){el.idx=(el.idx+1)%n;el.src=rend(urls[el.idx],cw);el.load();if(running){var p=el.play();if(p&&p.catch)p.catch(function(){});}});
      box.appendChild(el);cols.push(el);
    })(k);}
    box.hidden=false;
  }
  build();
  var api={play:function(){running=true;cols.forEach(function(el,i){el.muted=muted||i>0;var p=el.play();if(p&&p.catch)p.catch(function(){});});},
    pause:function(){running=false;cols.forEach(function(el){el.pause();});},
    toggleMute:function(){muted=!muted;cols.forEach(function(el,i){el.muted=muted||i>0;});return muted;}};
  var t;window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(function(){var was=running;api.pause();build();if(was)api.play();},300);});
  if(autoplay)api.play();
  return api;
};
